// extracted by mini-css-extract-plugin
module.exports = {"root":"ClearentDisclaimer_root__2yk-3","header":"ClearentDisclaimer_header__20vbc","inner":"ClearentDisclaimer_inner__1nST-"};